var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"bg"},[(!this.$route.query.json && !this.$route.query.code)?_c('div',[_vm._v("公众号授权")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }